/**
 * Version of the app, shown on the profile page.
 * One place for all environment files (DE dev/prod, later the Irish ones) – change it only here.
 */
export const APP_VERSION = '1.1.9';
